import { TwitterInfluencers, TwitterInfluencerProfile } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSocialAccountSelectButtonProps } from './hooks';

export const TwitterInfluencersSearch = () => {
  const { getSortSelectButtonProps, getListSelectButtonProps } =
    useSocialAccountSelectButtonProps<TwitterInfluencerProfile>({
      socialMedia: InfluencersTabType.TWITTER
    });

  return (
    <TwitterInfluencers
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
